import { BusinessService } from "@/common/api.service";
import {
  GET_BUSINESS_LIST,
  UPDATE_BUSINESS_STATUS,
  DELETE_BUSINESS,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";
const state = {
  errors: null,
  business_list: {},
};

const getters = {
  business_list(state) {
    return state.business_list;
  },
};

const actions = {
  // Get Business List
  async [GET_BUSINESS_LIST](context, payload) {
    BusinessService.init();
    BusinessService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      BusinessService.get(`business/list${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update Business Status
  async [UPDATE_BUSINESS_STATUS](context, payload) {
    BusinessService.init();
    BusinessService.setHeader();
    return new Promise((resolve) => {
      BusinessService.put(`business/actions/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Delete Business
  async [DELETE_BUSINESS](context, payload) {
    BusinessService.init();
    BusinessService.setHeader();
    return new Promise((resolve) => {
      BusinessService.put(`business/actions/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
